import util from '@/plugins/custom-util/index'

function install (Vue, store) {
  if (install.installed) return
  install.installed = true

  // 将组件进行全局注册

  // 给Vue的实例定义一个this.$go()、this.$replace()、this.$push()代替
  // 当前页面向前或向后跳转多少个页面
  Vue.prototype.$go = function (path) {
    this.$router.go(path)
  }
  // 不会向history里面添加新的记录，点击返回，会跳转到上上一个页面。
  Vue.prototype.$replace = function (path) {
    this.$router.replace(path)
  }
  // 向history栈添加一个记录，点击后退会返回到上一个页面。
  Vue.prototype.$push = function (path) {
    this.$router.push(path)
  }
  // 挂载自定义js
  Vue.prototype.$customUtil = util
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/plugins/index.js